import React, { useMemo, useEffect, useState } from 'react'
import { MdDateRange } from 'react-icons/md'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { generateArrayOfYears } from '../../../utils/date'
import Flex from '../Flex/Flex'
import Modal from '../Modal/Modal'
import Text from '../Text/Text'
import Button from '../Button/Button'
import styles from './datePicker.module.scss'

const months = [
  {
    value: '01',
    shortName: 'Jan'
  },
  {
    value: '02',
    shortName: 'Fev'
  },
  {
    value: '03',
    shortName: 'Mar'
  },
  {
    value: '04',
    shortName: 'Abr'
  },
  {
    value: '05',
    shortName: 'Mai'
  },
  {
    value: '06',
    shortName: 'Jun'
  },
  {
    value: '07',
    shortName: 'Jul'
  },
  {
    value: '08',
    shortName: 'Ago'
  },
  {
    value: '09',
    shortName: 'Set'
  },
  {
    value: '10',
    shortName: 'Out'
  },
  {
    value: '11',
    shortName: 'Nov'
  },
  {
    value: '12',
    shortName: 'Dez'
  }
]

const getCurrentMonthAndYear = () => {
  const date = new Date()

  return {
    month:
      date.getMonth() < 10
        ? `0${date.getMonth() + 1}`
        : String(date.getMonth()),
    year: String(date.getFullYear())
  }
}

const DatePicker = ({ applyFilter, initialValue, className, tag }) => {
  const currentDate = useMemo(() => getCurrentMonthAndYear())
  const [visible, setVisible] = useState(false)
  const [month, setMonth] = useState(initialValue.month || currentDate.month)
  const [year, setYear] = useState(initialValue.year || currentDate.year)
  const [years, setYears] = useState([])

  useEffect(() => {
    setMonth(initialValue.month || currentDate.month)
    setYear(initialValue.year || currentDate.year)
  }, [initialValue])

  function getMonth(value) {
    const find = months.filter((item) => item.value === value)

    return find[0]?.shortName ? find[0]?.shortName : null
  }

  useEffect(() => {
    const items = generateArrayOfYears().flatMap((item, index) => {
      return {
        id: index,
        value: item
      }
    })
    setYears(items)
  }, [])

  const containerButton = classNames(styles.container, className, {
    [styles.tag]: tag
  })

  return (
    <>
      <button
        id="button-visible"
        type="button"
        className={containerButton}
        onClick={() => setVisible(true)}
      >
        {`${getMonth(month)} ${year}`}
        <MdDateRange color="#4d4d4d" style={{ marginLeft: 5 }} />
      </button>
      <Modal rounded visible={visible} onClickOverlay={() => setVisible(false)}>
        <Flex column alignItems="center">
          <Text color="gray" variation="dark" extraBold>
            Período Visível
          </Text>
          <Flex
            alignItems="center"
            justifyContent="space-between"
            width="34%"
            margin="20px 0px"
          >
            <Text color="gray" variation="dark" extraBold>
              Mês
            </Text>
            <Text color="gray" variation="dark" extraBold>
              Ano
            </Text>
          </Flex>
          <Flex alignItems="center" height="220px">
            <div className={styles.select}>
              {months.map((item) => (
                <label
                  key={item.value}
                  className={item.value === month ? styles.selected : ''}
                  onClick={() => setMonth(item.value)}
                >
                  {item.shortName}
                </label>
              ))}
            </div>
            <div className={styles.select}>
              {years.map((item) => (
                <label
                  key={item.value}
                  className={item.value === year ? styles.selected : ''}
                  onClick={() => setYear(item.value)}
                >
                  {item.value}
                </label>
              ))}
            </div>
          </Flex>

          <Button
            type="secondary"
            buttonType="button"
            onClick={() => {
              setVisible(false)
              applyFilter({
                month,
                year
              })
            }}
          >
            Aplicar Filtro
          </Button>
        </Flex>
      </Modal>
    </>
  )
}

DatePicker.defaultProps = {
  initialValue: {
    month: null,
    year: null
  },
  tag: false,
  className: null
}

DatePicker.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({
    month: PropTypes.string,
    year: PropTypes.string
  }),
  tag: PropTypes.bool,
  className: PropTypes.string
}

export default DatePicker
